import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    marginRight: 'auto',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end',
      marginRight: 0,
    },
  },
  list: {
    '& .MuiPaginationItem-page.Mui-selected': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.common.white,
      '& .Mui-focusVisible': {
        backgroundColor: theme.palette.primary.light,
      },
    },
  },
}))

export default useStyles
